import request from '@/utils/request'


// 查询商品规格属性值列表
export function listSpec(query) {
  return request({
    url: '/goods/spec/list',
    method: 'get',
    params: query
  })
}

// 查询商品规格属性值分页
export function pageSpec(query) {
  return request({
    url: '/goods/spec/page',
    method: 'get',
    params: query
  })
}

// 查询商品规格属性值详细
export function getSpec(data) {
  return request({
    url: '/goods/spec/detail',
    method: 'get',
    params: data
  })
}

// 新增商品规格属性值
export function addSpec(data) {
  return request({
    url: '/goods/spec/add',
    method: 'post',
    data: data
  })
}

// 修改商品规格属性值
export function updateSpec(data) {
  return request({
    url: '/goods/spec/edit',
    method: 'post',
    data: data
  })
}

// 删除商品规格属性值
export function delSpec(data) {
  return request({
    url: '/goods/spec/delete',
    method: 'post',
    data: data
  })
}
